require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-matteo-iannello-architettura-scolastica-e-costruzione-dello-spazio-urbano-nel-cantone-ticino-1945-1980-monte-carasso-1-luglio-2019.json") })
        }
      }, "path---relazioni-e-conferenze-matteo-iannello-architettura-scolastica-e-costruzione-dello-spazio-urbano-nel-cantone-ticino-1945-1980-monte-carasso-1-luglio-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-matteo-iannello-architettura-scolastica-e-costruzione-dello-spazio-urbano-nel-cantone-ticino-1945-1980-monte-carasso-1-luglio-2019!./.cache/json/relazioni-e-conferenze-matteo-iannello-architettura-scolastica-e-costruzione-dello-spazio-urbano-nel-cantone-ticino-1945-1980-monte-carasso-1-luglio-2019.json
// module id = 705
// module chunks = 231608221292675